<template>
  <div class="music-library spotify-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Music Library</h4>
              </div>
            </div>
          </div>
          <SpotifyPlaylists
            client_name="MID"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import SpotifyPlaylists from "@/components/music_library/SpotifyPlaylists.vue";

export default {
  name: "MIDSpotifyPlaylists",
  components: { SpotifyPlaylists },
  data() {
    return {
     
    };
  },
  mounted() {
    // this.getEventsList();
  },
  computed: {},
  created() {},
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/music_library/SpotifyPlaylists.vue